import React from "react";
import {connect} from "react-redux";
import {Button, Form, Input, Modal, Select, Space} from "antd";
import {normalizeEnum} from "../../libs/utils";

class IPNodeIPAddressFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFilter: 'IP_ADDRESS',
            filterValue: '',
            filterKey: 'ip_address',
            filterVisible: null,
        };
    }

    onChange(){
        let visibleValue = null;

        this.props.onChange({
            name: normalizeEnum(this.state.selectedFilter),
            key: this.state.filterKey,
            value: this.state.filterValue.trim(),
            visible: visibleValue
        });
    }

    closeModal(apply = false, close = true) {
        this.setState({
            selectedFilter: 'STATUS',
            filterValue: '',
            filterKey: 'status',
            filterVisible: null,
        });

        if(close) {
            this.props.closeModal();
        }

        if(apply) {
            this.onChange();
        }
    }

    setFilter(name) {
        const filters = {
            STATUS: { key: 'status', value: 'ACTIVE' },
            IP_ADDRESS: { key: 'ip_address', value: '' },
            IS_AVAILABLE: { key: 'is_available', value: '' },
        };

        this.setState({ selectedFilter: name, filterKey: filters[name].key, filterValue: filters[name].value });
    }

    render() {
        const { Option } = Select;

        let content = '';

        if(this.state.selectedFilter === 'STATUS') {
            content = <Select onChange={(value) => this.setState({filterValue: value})}>
                <Option value='ACTIVE'>Active</Option>
                <Option value='DISABLED'>Disabled</Option>
                <Option value='DELETED'>Deleted</Option>
            </Select>
        } else if(this.state.selectedFilter === 'IS_AVAILABLE') {
            content = <Select onChange={(value) => this.setState({ filterValue: value })}>
                <Option value='1'>Online</Option>
                <Option value='0'>Offline</Option>
            </Select>
        } else if(this.state.selectedFilter === 'IP_ADDRESS') {
            content = <Input value={this.state.filterValue}
                             onChange={(e) => this.setState({filterValue: e.target.value})}/>;
        }

        return(
            <Modal
                title='Add Filter'
                destroyOnClose={true}
                onCancel={() => this.closeModal()}
                footer={<Space>
                    <Button onClick={() => this.closeModal()}>Close</Button>
                    <Button onClick={() => this.closeModal(true, false)}>Apply</Button>
                    <Button type='primary' onClick={() => this.closeModal(true, true)}>Apply & Close</Button>
                </Space>}
                open={this.props.showModal}>
                <Form layout='vertical'>
                    <Form.Item label='Select filter:'>
                        <Select value={this.state.selectedFilter} onChange={(value) => this.setFilter(value)}>
                            <Option value='IP_ADDRESS'>IP address</Option>
                            <Option value='STATUS'>Status</Option>
                            <Option value='IS_AVAILABLE'>Is online</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        {content}
                    </Form.Item>
                </Form>
            </Modal>
        )
    }
}

export default connect(null, { })(IPNodeIPAddressFilter);